import React, { useCallback } from "react";
import PlusIcon from "../../../assets/icons/PlusIcon";
import TickIcon from "../../../assets/icons/TickIcon";
import Text from "../../../components/Text/Text";
import VerifiedIcon from "../../../assets/icons/VerifiedIcon";
import { Community } from "../utils/commsParser";
import { ReactComponent as InstagramIcon } from "../../../assets/icons/insta-icon.svg";
import { ReactComponent as LinkedinIcon } from "../../../assets/icons/linkedin-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../../assets/icons/youtube-icon.svg";
import BorderCircle from "../../../assets/icons/BorderCircle";
import { is } from "immer/dist/internal";

export interface CommunityBoxProps {
    isSelected: boolean;
    community: Community;
    toggleCommunityHandler: (community: Community) => void;
}

const SocialMediaIcons: Record<string, JSX.Element> = {
    youtube: <InstagramIcon />,
    linkedin: <LinkedinIcon />,
    instagram: <YoutubeIcon />,
};

const CommunityBox: React.FC<CommunityBoxProps> = ({
    isSelected,
    community,
    toggleCommunityHandler,
}) => {
    const handleToogler = () => {
        toggleCommunityHandler(community);
    };
    const renderBox = useCallback(() => {
        return (
            <div
                className="space-between relative flex h-[87px] w-[full] flex-col justify-between  px-[6px] pb-[8px] pt-[6px]"
                onClick={handleToogler}
            >
                <div className="w-fit self-end">
                    {isSelected ? <TickIcon /> : <BorderCircle />}
                </div>

                <Text type="L1" color="#FFF">
                    {community.name}
                </Text>

                <div
                    style={{
                        zIndex: "-10",
                        top: "0",
                        left: "0",
                        position: "absolute",
                        width: "100%",
                        height: "87px",
                    }}
                >
                    <img
                        style={{
                            border: isSelected
                                ? "5px solid var(--Palette-Green-Green-500, #1F8268)"
                                : "none",
                            borderRadius: "8px",
                            // backgroundImage:
                            //     "linear-gradient(135deg, rgb(255,255,255), rgb(0,0,0,0))",
                        }}
                        className="h-full w-full rounded-[8px]"
                        src={community.logoUrl}
                    />
                </div>
                {
                    <div
                        className=" absolute top-0 left-0 z-10 z-[-10] h-[87px] w-full rounded-[8px] "
                        style={{
                            backgroundImage:
                                "linear-gradient(135deg, rgb(255,255,255,0), rgb(0,0,0,0,0))",
                            backgroundColor: isSelected
                                ? "rgb(0,0,0,0.2)"
                                : "rgb(0,0,0,0.5)",
                        }}
                    />
                }
            </div>
        );
    }, [isSelected]);
    return <>{renderBox()}</>;
};

export default CommunityBox;
